import styled from 'styled-components';
import _TableCell from '../../atoms/table/TableCell';
export const TableCell = styled(_TableCell) `
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    gap: 10px;
`;
